type Rect = Pick<DOMRect, 'top' | 'right' | 'bottom' | 'left'>;

const MARGIN = 16;
// The company map lays its search and filter row over the top of the map.
const TOP_MARGIN = 64;

// A card taller than the room it has keeps its top, with the name and close button, in view.
const overflow = (start: number, end: number, low: number, high: number) => {
	if (end - start > high - low || start < low) {
		return start - low;
	}
	return end > high ? end - high : 0;
};

export const panIntoViewOffset = (popup: Rect, container: Rect): [number, number] => [
	overflow(popup.left, popup.right, container.left + MARGIN, container.right - MARGIN),
	overflow(popup.top, popup.bottom, container.top + TOP_MARGIN, container.bottom - MARGIN)
];
